import React, { type ComponentType } from 'react';
import '@atlaskit/css-reset';
import PageAppInitialisationAnalytics from '@atlassian/jira-common-analytics-page-app-initialisation';
import QueryParamAdapter from '@atlassian/jira-project-directories-components/src/query-param-adapter';
import {
	RedirectToArchivedPage,
	isProjectArchivedCondition,
} from '@atlassian/jira-redirect-archived-project';
import { withRouter, type RouteContext, useResource } from '@atlassian/jira-router';
import { projectsComponentsResource } from '@atlassian/jira-router-resources-project-components';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';

import Components from './view';

export type Props = RouteContext;

export const ProjectComponents = ({ location, match }: Props) => {
	const prefetchResult = useResource(projectsComponentsResource);
	const projectContext = useResource(projectContextResource);
	const tenantContext = useTenantContext();

	const { projectKey } = match.params;

	if (isProjectArchivedCondition(projectContext.data)) {
		return <RedirectToArchivedPage />;
	}

	return (
		<AuthenticationCheck>
			{projectKey && projectContext ? (
				<QueryParamAdapter location={location}>
					{({ query, onQueryChanged }) => (
						<Components
							projectContext={projectContext}
							tenantContext={tenantContext}
							prefetchResult={{ ...prefetchResult }}
							query={query}
							onQueryChanged={onQueryChanged}
						/>
					)}
				</QueryParamAdapter>
			) : null}
		</AuthenticationCheck>
	);
};

// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
const RouterWrapper: ComponentType<{}> = withRouter(ProjectComponents);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<>
		<MarkProductStart />
		<PageAppInitialisationAnalytics
			appNameSuffixForV2Event="project.components"
			appNameForV3OperationalEvent="componentsProject"
		/>
		<RouterWrapper />
	</>
);
